import { TScreenState } from '../../Types';

/**
 * Maybe switch this if device is Mobile or Desktop ?
 */
export const initialScreenState: TScreenState = {
  isSidePanelOpen: true,
};
